import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ArticlesEffects } from './articles.effects';
import * as ArticlesReducer from './articles.reducer';
import { articlesFeatureKey } from './articles.state';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(articlesFeatureKey, ArticlesReducer.reducer), EffectsModule.forFeature([ArticlesEffects])],
})
export class ArticlesStoreModule {}
